const typeChoices = [
  { id: 'ARCHIVE_ALREADY_SPLIT', code: 4, name: 'Already Split' },
  { id: 'SINGLE_FILE_WITH_SPLIT_TAGS', code: 1, name: 'Coordinates' }
];

const matchingFields = [
  { id: 1, name: 'Tax ID' },
  { id: 2, name: 'A.K.A Investor Name' },
  { id: 3, name: 'A.K.A Investor ID' },
  { id: 4, name: 'Cross Reference' },
  { id: 5, name: 'Alternative Tax ID' }
];

export { typeChoices, matchingFields };
